var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefitMetatrade3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 89,
    viewBox: "0 0 88 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 89,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.401 66.5545C4.6261 60.7796 1 52.7216 1 43.7236C1 34.8598 4.6261 26.8018 10.401 20.8926",
    stroke: "#057EE6",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.064 20.8926C61.8389 26.6675 65.465 34.7255 65.465 43.7236C65.465 52.5873 61.8389 60.6453 56.064 66.5545",
    stroke: "#057EE6",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.041 60.914C11.7434 56.4821 8.9231 50.4386 8.9231 43.7236C8.9231 37.0086 11.6091 30.9651 16.041 26.5332",
    stroke: "#057EE6",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4233 26.5332C54.8552 30.9651 57.5412 37.0086 57.5412 43.7236C57.5412 50.4386 54.8552 56.4821 50.4233 60.914",
    stroke: "#057EE6",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6842 55.2734C18.7296 52.3188 16.8494 48.2898 16.8494 43.7236C16.8494 39.1574 18.7296 35.1284 21.6842 32.1738",
    stroke: "#057EE6",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7812 32.1738C47.7358 35.1284 49.616 39.1574 49.616 43.7236C49.616 48.2898 47.7358 52.3188 44.7812 55.2734",
    stroke: "#057EE6",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2338 52.0502C37.8325 52.0502 41.5604 48.3222 41.5604 43.7236C41.5604 39.1249 37.8325 35.397 33.2338 35.397C28.6352 35.397 24.9072 39.1249 24.9072 43.7236C24.9072 48.3222 28.6352 52.0502 33.2338 52.0502Z",
    stroke: "#057EE6",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitMetatrade3);
export default __webpack_public_path__ + "static/media/benefit-metatrade-3.6f607a35523c531c07f6a9a831bb2c58.svg";
export { ForwardRef as ReactComponent };